export default __webpack_public_path__ + "static/media/dog-party.4b1042d7.jpg";